import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(
  ({ url = '/assets/logos/asap1.png', alt = 'ASAP Marketing and Studies Consultancy', disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box
      ref={disabledLink ? ref : undefined}
      component="img"
      src={url}
      alt={alt}
      sx={{ display: 'block', height: 30, width: 'auto', ...sx }}
      {...(disabledLink ? other : {})}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link
      ref={ref}
      to="/"
      component={RouterLink}
      aria-label="ASAP Marketing and Studies Consultancy home"
      underline="none"
      sx={{ display: 'inline-flex', flexShrink: 0 }}
      {...other}
    >
      {logo}
    </Link>
  );
  }
);

Logo.propTypes = {
  sx: PropTypes.object,
  url: PropTypes.string,
  alt: PropTypes.string,
  disabledLink: PropTypes.bool,
};

export default Logo;
